/**
 * Strip a leading catalog ID prefix from a doc title for display.
 * Removes patterns like "GOV-001: ", "FAQ-012. ", "AST-3 - ", "SOP-10 " (with optional
 * separator: colon, dot, dash, or just a space). Does NOT modify the source string
 * in the database — display only.
 */
const PREFIX_RE = /^\s*[A-Z]{2,4}-\d+\s*(?:[:.\u2013\u2014-]\s*)?/;

export function stripDocIdPrefix(title: string | null | undefined): string {
  if (!title) return "";
  return title.replace(PREFIX_RE, "").trim() || title;
}
